import { formatNumber } from 'core/service/lib/number-format'

export const dashedOutOrWithPrecision = (value, precision, isRound = true) =>
  value === 0 ? '-' : formatNumber(value, precision, isRound)

export const PolicyGioValueRow = ({
  age,
  yearEndPolicy,
  annualBasicPremium,
  cumulativeBasicPremium,
  cashDrop,
  lowSavingCashDrop,
  deathBenefit,
  deathBenefitPlusNonGuaranteeDividend,
  surrenderCash,
  surrenderCashPlusNonGuaranteeDividendSurrender,
}) => {
  return (
    <tr id={`policy-value-row-${age.value}`}>
      <td className="policy-value-age">{age.value}</td>
      <td className="policy-value-year">{yearEndPolicy}</td>
      <td className="policy-value-annual-basic-premium">{dashedOutOrWithPrecision(annualBasicPremium, 0)}</td>
      <td className="policy-value-cumulative-basic-premium">{dashedOutOrWithPrecision(cumulativeBasicPremium, 0)}</td>
      <td className="policy-value-cash-drop">{dashedOutOrWithPrecision(cashDrop, 0)}</td>
      <td className="policy-value-cash-drop">{dashedOutOrWithPrecision(lowSavingCashDrop, 0)}</td>
      <td className="policy-value-death-benefit">{dashedOutOrWithPrecision(deathBenefit, 0)}</td>
      <td className="policy-value-cumulative-death-benefit">
        {dashedOutOrWithPrecision(deathBenefitPlusNonGuaranteeDividend, 0)}
      </td>
      <td className="policy-value-surrender-cash">{dashedOutOrWithPrecision(surrenderCash, 0)}</td>
      <td className="policy-value-surrender-cash">
        {dashedOutOrWithPrecision(surrenderCashPlusNonGuaranteeDividendSurrender, 0)}
      </td>
    </tr>
  )
}
export default PolicyGioValueRow
